import { translate } from './TranslateComponent';


export const notificationRenderer = translate('notifications')(
    ({ content, t }) => t(content),
);
